module.exports = __webpack_public_path__ + "Roboto-MediumItalic.bae866b2b9f7b56fea62.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/assets/font/roboto/Roboto-MediumItalic.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-MediumItalic.woff
// module chunks = 2